import { render, staticRenderFns } from "./TopPrompt.vue?vue&type=template&id=7fd674ad&scoped=true&"
import script from "./TopPrompt.vue?vue&type=script&lang=js&"
export * from "./TopPrompt.vue?vue&type=script&lang=js&"
import style0 from "./TopPrompt.vue?vue&type=style&index=0&id=7fd674ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd674ad",
  null
  
)

export default component.exports